import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	RichText,
} from '@wordpress/block-editor';
import { Icon } from '@wordpress/icons';
import { omit } from 'lodash';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Save function.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */
export default function save ({attributes,className}){
        const 	info 		= attributes.info,
        		infoDown 	= attributes.infoDown;
        const {
        	TimeLine_heading,
        	CardColor,
        	CardLineColor,
        	start,
        	end,
        	titleFirst,
        	bgcolorFirst,
        	contentFirst,
        	mediaURLFirst,
        	yearFirst,
        	iconFirst,
        	prefixiconFirst,
        	titleSec,
        	bgcolorSec,
        	contentSec,
        	mediaURLSec,
        	yearSec,
        	iconSec,
        	prefixiconSec,
        } = attributes;

        library.add(fas);

        var merged_icons = Object.assign(fas, fab); 

    	var deficonFirst 		= [],
    	 	deficonSec 			= [],
    	 	deficonPrefFirst 	= [],
    	 	deficonPrefSec 		= [];


	 	jQuery.each(merged_icons, function(index, item) {
	 		if (item.iconName == iconFirst) {
	 			deficonFirst = item.iconName;
	 			deficonPrefFirst = item.prefix;
	 		}

	 		if (item.iconName == iconSec) {
	 			deficonSec = item.iconName;
	 			deficonPrefSec = item.prefix;
	 		}
	 	});

        const displayInfoList = (value) => {

        	if (value) {
	            return(
	                value.map( infoItem => {

	                	var num = infoItem.index;
	                	var	num_class = 'timeline-section ptl-row no-gutters even';
	                	var	date_class = 'pol-md-6';
	                	if(num % 2 == 0) {
	                	   num_class = 'timeline-section ptl-row no-gutters odd';
	                	   date_class = 'pol-md-6';
	                	}

	                    return(

								<div className={num_class}>

									<div className="cir-sec zoomIn" style={{ background:'#fff' ,  borderColor:infoItem.bgcolor }}></div>
										<div className= {date_class} >
											<div className= 'ptl-date-sec' >
												<h3 className="date fadeIn"  style={{ color:infoItem.bgcolor}}>
													<RichText.Content
														tagName="strong"
														value={infoItem.year}
													/>
												</h3>
											</div>
										</div>
									<div className="pol-md-6 data-box">
										<div className="ti-box">
											<div className="tag-span">
												<RichText.Content
													tagName="h2"
													className="ptl-p-title"
													value={infoItem.title}
													style={{ backgroundColor: infoItem.bgcolor}}
												/>
												<span className="ptl-h2-span" style={{ backgroundColor:infoItem.bgcolor}}></span>
											</div>
											<div className="p-collapse in">
												<div className="ptl-cont-box">
													<div className="ptl-img-cont"> 
														<img className="ptl-p-img" src={ infoItem.mediaURL } alt={ __( 'Image', 'p_timeline' ) } />
													</div>
													{ infoItem.description &&
														<div className="ptl-desc">
															<RichText.Content
																tagName="div"
																className="ptl-content"
																value={infoItem.description}
															/>
														</div>
													}
													
												</div>
											</div>
										</div>
									</div>

								</div>
	                    )
	                } )
	            )
        	}
        }

        const displayInfoListDown = (value) => {

        	if (value) {
	            return(
	                value.map( infoItem => {

	                	var num = infoItem.index;
	                	var	num_class = 'timeline-section ptl-row no-gutters even';
	                	var	date_class = 'pol-md-6';
	                	var deficon 	= [];
	                	var deficonprefix = [];

	                	if(num % 2 == 0) {
	                	   num_class = 'timeline-section ptl-row no-gutters odd';
	                	   date_class = 'pol-md-6';
	                	}

	                	jQuery.each(merged_icons, function(index, item) {

	                	    if (item.iconName == infoItem.icon) {
	                	        deficon = item.iconName;
	                	        deficonprefix = item.prefix;
	                	    }
	                	});

	                	var fdeficon = {'prefix':deficonprefix,'iconName': deficon};
	                	
	                    return(

								<div className={num_class}>

									<div className="cir-sec zoomIn" style={{ background:'#fff' ,  borderColor:infoItem.bgcolor }}>
										<div className="ptl-icon-cont">
										{ deficon &&
										   <FontAwesomeIcon 
										   icon= {fdeficon}
										   style={{color:infoItem.bgcolor}}
										   />
										}
										</div>
									</div>
										<div className= {date_class} >
											<div className= 'ptl-date-sec' >
												<h3 className="date fadeIn"  style={{ color:infoItem.bgcolor}}>
													<RichText.Content
														tagName="strong"
														value={infoItem.year}
													/>
												</h3>
											</div>
										</div>
									<div className="pol-md-6 data-box">
										<div className="ti-box">
											<div className="tag-span">
												<RichText.Content
													tagName="h2"
													className="ptl-p-title"
													value={infoItem.title}
													style={{ backgroundColor: infoItem.bgcolor}}
												/>
												<span className="ptl-h2-span" style={{ backgroundColor:infoItem.bgcolor}}></span>
											</div>
											<div className="p-collapse in">
												<div className="ptl-cont-box">
													{ 0 != infoItem.mediaURL &&
														<div className="ptl-img-cont"> 
															<img className="ptl-p-img" src={ infoItem.mediaURL } alt={ __( 'Image', 'p_timeline' ) } />
														</div>
													}
													{ infoItem.description &&
														<div className="ptl-desc">
															<RichText.Content
																tagName="div"
																className="ptl-content"
																value={infoItem.description}
															/>
														</div>
													}

												</div>
											</div>
										</div>
									</div>

								</div>
	                    )
	                } )
	            )
        	}
        }
        var ficonFirst = {'prefix':prefixiconFirst,'iconName': iconFirst};
        var ficonSec = {'prefix':prefixiconSec,'iconName': iconSec};

        return(
				<div className="main-timeline post-timeline"  style={{ backgroundColor: attributes.CardColor}}>

					<div className="container">
						<div className="ptl-posts-cont p-tl-cont ptl-front-cont ptl-cont">
							<div className="ptl-container">
								<div className="ptl-row justify-content-center">
									<div className="pol-md-11 pol-sm-12">

										<div className="ptl-post-block-head">
										    <RichText.Content
										        tagName="h3"
										        className="ptl-post-heading"
										        value={TimeLine_heading}
										        style={{color: attributes.CardLineColor}}
										    />
										</div>
										<div className="ptl-content-sec">
											<span className="ptl-center-line" style={{background: attributes.CardLineColor}}></span>
											<div className="ptl-sec-yr" style={{background: attributes.CardLineColor}}>{attributes.start}</div>

											{ displayInfoList(info) }

											<div className='timeline-section ptl-row no-gutters odd'>

												<div className="cir-sec zoomIn" style={{ background:'#fff' ,  borderColor: attributes.bgcolorFirst }}>
													<div className="ptl-icon-cont">
														{ deficonFirst &&
														   <FontAwesomeIcon 
														   icon = {ficonFirst}
														   style={{color:attributes.bgcolorFirst}}
														   />
														}
													</div>
												</div>
												<div className= 'pol-md-6' >
													<div className= 'ptl-date-sec' >
														<h3 className="date fadeIn" style={{ color:attributes.bgcolorFirst}}>
															<RichText.Content
																tagName="strong"
																value={attributes.yearFirst}
															/>
														</h3>
													</div>
												</div>
												<div className="pol-md-6 data-box">
													<div className="ti-box">
													<div className="tag-span">
														<RichText.Content
															tagName="h2"
															className="ptl-p-title"
															value={attributes.titleFirst}
															style={{ backgroundColor: attributes.bgcolorFirst}}
														/>
															<span className="ptl-h2-span" style={{ backgroundColor:attributes.bgcolorFirst}}></span>
														</div>
														<div className="p-collapse in">
															<div className="ptl-cont-box">
																{ 0 != attributes.mediaURLFirst  &&
																	<div className="ptl-img-cont"> 
																		<img className="ptl-p-img" src={ attributes.mediaURLFirst } alt={ __( 'Image', 'p_timeline' ) } />
																	</div>
																}
																{ attributes.contentFirst &&
																	<div className="ptl-desc">
																		<RichText.Content
																			tagName="div"
																			className="ptl-content"
																			value={attributes.contentFirst}
																		/>
																	</div>
																}
															</div>
														</div>
													</div>
												</div>

											</div>

											<div className='timeline-section ptl-row no-gutters even'>

												<div className="cir-sec zoomIn" style={{ background:'#fff' ,  borderColor: attributes.bgcolorSec }}>
													<div className="ptl-icon-cont">
														{ deficonFirst &&
														   <FontAwesomeIcon 
														   icon = {ficonSec}
														   style={{color:attributes.bgcolorSec}}
														   />
														}
													</div>
												</div>
												<div className= 'pol-md-6' >
													<div className= 'ptl-date-sec' >
														<h3 className="date fadeIn" style={{ color:attributes.bgcolorSec }}>
															<RichText.Content
																tagName="strong"
																value={attributes.yearSec}
															/>
														</h3>
													</div>
												</div>
												<div className="pol-md-6 data-box fadeIn panim">
													<div className="ti-box">
														<div className="tag-span">
															<RichText.Content
																tagName="h2"
																className="ptl-p-title"
																value={attributes.titleSec}
																style={{ backgroundColor: attributes.bgcolorSec}}
															/>
															<span className="ptl-h2-span" style={{ backgroundColor:attributes.bgcolorSec}}></span>
														</div>
														<div className="p-collapse in">
															<div className="ptl-cont-box">
																{ 0 != attributes.mediaURLSec &&
																	<div className="ptl-img-cont"> 
																		<img className="ptl-p-img" src={ attributes.mediaURLSec } alt={ __( 'Image', 'p_timeline' ) } />
																	</div>
																}
																<div className="ptl-desc">
																	<RichText.Content
																		tagName="div"
																		className="ptl-content"
																		value={attributes.contentSec}
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>

											</div>

											
								        
									        { displayInfoListDown(infoDown) }

									        <RichText.Content
											tagName="div" 
											className="ptl-sec-yr ptl-last" 
											value = {attributes.end}
											style={{background: attributes.CardLineColor}}
											/>
										</div>

								    </div>
								</div>
							</div>
						</div>
					</div>

				</div>
	        );
}